'use client';
import { Outlet } from 'react-router-dom';

import { Header } from '@/components';
import { useUserInfo } from '@/hooks';

import { SetNameModal } from './_components/SetNameModal';

export default function MainLayout() {
  const { user } = useUserInfo();
  return (
    <div className="w-full h-full bg-background">
      <Header user={user} />
      <div className="pt-[72px] h-full">
        <Outlet />
      </div>
      <SetNameModal user={user!} />
    </div>
  );
}
